import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import VenueSelect from '../Navigation/VenueSelect.js';
import UKDashboard from '../UK/UKDashboard/UKDashboard.js';

const Welcome = () => {
    const { initialLoginData, ukEntityData } = useSelector((state) => state.user);
    console.log('Initial Login Data:', initialLoginData);
    const hasVenues = initialLoginData?.data?.InitialLoginData || ukEntityData.length > 0;
    const isUK = ukEntityData.length > 0;

    return (
        <>
            {!isUK ? (
                <Card className="mt-5 p-3 text-center">
                    <Card.Title>Welcome to MyGymTV!</Card.Title>
                    <Card.Body>
                        {hasVenues ? (
                            <div>
                                <p>Please select a Venue to continue.</p>
                                <VenueSelect />
                            </div>
                        ) : (
                            <div>
                                <p>You don't have any venues assigned to your account.</p>
                                <p>
                                    Please contact <a href="mailto:training@clubcom.com">training@clubcom.com</a> for assistance.
                                </p>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            ) : (
                <UKDashboard />
            )}
        </>
    );
};

export default Welcome;
